var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageWrapper", {
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "el-header",
              {
                ref: "header",
                staticClass: "header",
                staticStyle: { height: "auto", padding: "10px" },
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "searchFormRef",
                    staticClass: "demo-form-inline",
                    attrs: { inline: true, model: _vm.searchForm },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { id: "searchBox" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "xhname" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "型号" },
                              nativeOn: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleSearchBtn.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.searchForm.xhname,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "xhname", $$v)
                                },
                                expression: "searchForm.xhname",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "xhname_ct" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "型号包含" },
                              nativeOn: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleSearchBtn.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.searchForm.xhname_ct,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "xhname_ct", $$v)
                                },
                                expression: "searchForm.xhname_ct",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "xhname_nct" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "型号不包含" },
                              nativeOn: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleSearchBtn.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.searchForm.xhname_nct,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "xhname_nct", $$v)
                                },
                                expression: "searchForm.xhname_nct",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "source" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入品牌" },
                              nativeOn: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleSearchBtn.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.searchForm.source,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "source", $$v)
                                },
                                expression: "searchForm.source",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          { attrs: { label: "", prop: "gongyingshang" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入供应商" },
                              nativeOn: {
                                keydown: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleSearchBtn.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                              model: {
                                value: _vm.searchForm.gongyingshang,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "gongyingshang", $$v)
                                },
                                expression: "searchForm.gongyingshang",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { type: "text", id: "closeSearchBtn" },
                            on: { click: _vm.closeSearch },
                          },
                          [
                            _vm._v(" " + _vm._s(_vm.word) + " "),
                            _c("i", {
                              class: _vm.showAll
                                ? "el-icon-arrow-up "
                                : "el-icon-arrow-down",
                            }),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              icon: "el-icon-search",
                            },
                            on: { click: _vm.handleSearchBtn },
                          },
                          [_vm._v("搜索 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", icon: "el-icon-refresh" },
                            on: { click: _vm.handleResetBtn },
                          },
                          [_vm._v("重置")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "upload-container" },
              [
                _c(
                  "el-button",
                  {
                    directives: [{ name: "waves", rawName: "v-waves" }],
                    staticClass: "filter-item",
                    attrs: {
                      loading: _vm.importLoading,
                      type: "warning",
                      icon: "el-icon-plus",
                      size: "small",
                    },
                    on: { click: _vm.handleImport },
                  },
                  [_vm._v("导入Excel ")]
                ),
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading",
                      },
                    ],
                    staticClass: "customer-table",
                    attrs: {
                      border: "",
                      fit: "",
                      "highlight-current-row": "",
                      data: _vm.list,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "ID", prop: "id", width: "80" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "型号", prop: "xhname", width: "200" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "品牌", prop: "source", width: "200" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "数量", prop: "number" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "原币种", prop: "currency" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "原币价格", prop: "price", width: "100" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "成本价格",
                        prop: "cost_price",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "销售价格",
                        prop: "selling_price",
                        width: "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "货期", prop: "hq" },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "供应商",
                        prop: "gongyingshang",
                        width: "280",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "上传日期",
                        prop: "upload_date",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "库存版本",
                        prop: "version",
                        width: "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "备注", prop: "bz", width: "200" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "250" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "warning",
                                    size: "small",
                                    disabled:
                                      scope.row.state === "T" ||
                                      _vm.disabledIndexes.includes(
                                        scope.row.id
                                      ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.addToDrawer(
                                        scope.row,
                                        2,
                                        scope.$index
                                      )
                                    },
                                  },
                                },
                                [_vm._v("添加 ")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "el-icon-edit-outline",
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(scope)
                                    },
                                  },
                                },
                                [_vm._v(" 编辑 ")]
                              ),
                              _c(
                                "el-popconfirm",
                                {
                                  attrs: {
                                    iconColor: "red",
                                    title: "确认删除此条数据吗？",
                                  },
                                  on: {
                                    confirm: function ($event) {
                                      return _vm.handleDelete(
                                        scope,
                                        scope.$index
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "el-icon-delete",
                                      attrs: {
                                        slot: "reference",
                                        size: "small",
                                        type: "danger",
                                      },
                                      slot: "reference",
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
                _c("el-pagination", {
                  staticStyle: {
                    "margin-top": "14px",
                    "margin-bottom": "14px",
                  },
                  attrs: {
                    "current-page": _vm.selectPage.pageNum,
                    "page-sizes": [20, 50, 100, 200],
                    "page-size": _vm.selectPage.pageSize,
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.allNum,
                  },
                  on: {
                    "size-change": _vm.pageSizeChange,
                    "current-change": _vm.pageCurrentChange,
                  },
                }),
                _c("Import", {
                  attrs: {
                    dialog: _vm.dialogImport,
                    "form-data": _vm.editFormData,
                    type: _vm.type,
                    submitLoading: _vm.submitLoading,
                  },
                  on: {
                    close: _vm.handleImportClose,
                    uploadSuccess: _vm.handleUpload,
                    submit: _vm.handleSubmit,
                  },
                }),
                _c(
                  "el-button",
                  {
                    staticClass: "add-btn",
                    attrs: { type: "primary", plain: "" },
                    on: { click: _vm.handleAddXname },
                  },
                  [
                    _vm._v(
                      "已添加（" +
                        _vm._s(_vm.addedData.length || _vm.addedNum) +
                        "）"
                    ),
                  ]
                ),
                _c("AddCart", {
                  attrs: { data: _vm.addedData, dialog: _vm.drawerVisible },
                  on: {
                    removeFromDrawer: _vm.removeFromDrawer,
                    handleCloseAddCart: _vm.handleCloseAddCart,
                    handleClear: _vm.handleClear,
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }